import module from './module.js'
// Components
import './components/component.js'
import './components/agregar/component.js'
import './components/chequeras/component.js'
import './components/launcher/component.js'
import './components/lista/component.js'
import './components/lista/item/component.js'
import './components/listado/component.js'
import './components/listado/lista/component.js'
import './components/listado/lista/item/component.js'
// Direcives
import './directives/string-to-number/directive.js'
// Routes
import './routes/cheques.js'
import './routes/cheques/agregar.js'
import './routes/cheques/chequeras.js'
import './routes/cheques/listado.js'
// Services
import './services/Cheque.js'
import './services/ChequeEmpleados.js'
import './services/Cheques.js'
import './services/ChequesBeneficiarios.js'
import './services/ChequesEmpresas.js'
import './services/ChequesEmpresasCuentaBancariaCheques.js'
import './services/ChequesEmpresasCuentaBancariaChequesCheque.js'
import './services/ChequesGastos.js'
import './services/ChequesLeyendas.js'
import './services/ChequesProyectos.js'

export default module.name



// WEBPACK FOOTER //
// ./src/cheques/index.js